"use client";

import Image from "next/image";
import { useEffect, useState } from "react";
import { useTranslations } from "next-intl";

// Module-level variable to track if the poster has been shown in the current page session.
// This persists across client-side navigation and language toggles, but resets on full reload.
let hasShownPoster = false;

export default function PosterPopup() {
  const [show, setShow] = useState(false);
  const t = useTranslations("poster");

  const close = () => setShow(false);

  // Her sayfa yüklenişinde kısa bir gecikmeyle göster (sayfa ömrü boyunca bir kez)
  useEffect(() => {
    if (hasShownPoster) return;

    const timer = setTimeout(() => {
      setShow(true);
      hasShownPoster = true;
    }, 800);

    return () => clearTimeout(timer);
  }, []);

  // Escape ile kapat + arka plan kaydırmasını kilitle
  useEffect(() => {
    if (!show) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setShow(false);
    };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [show]);

  if (!show) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label={t("dialogLabel")}
      className="fixed inset-0 z-[60] flex items-center justify-center p-4 sm:p-6"
    >
      {/* Karartma */}
      <div
        onClick={close}
        aria-hidden
        className="absolute inset-0 bg-ink-deep/70 backdrop-blur-sm"
      />

      {/* Afiş — tamamı ekrana sığar, kaydırma yok */}
      <div className="animate-fade-up relative overflow-hidden rounded-3xl shadow-card-lg">
        <button
          type="button"
          onClick={close}
          aria-label={t("closeAria")}
          className="absolute right-3 top-3 z-10 inline-flex items-center gap-1.5 rounded-full bg-ink-deep/85 px-4 py-2.5 text-sm font-semibold text-white shadow-card-lg ring-2 ring-white/80 backdrop-blur-sm transition-all hover:scale-105 hover:bg-brand"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden>
            <path
              d="M6 6l12 12M18 6L6 18"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
            />
          </svg>
          {t("close")}
        </button>

        <Image
          src="/images/afis.jpeg"
          alt={t("alt")}
          width={714}
          height={1280}
          priority
          className="block h-auto max-h-[92dvh] w-auto max-w-[92vw]"
        />
      </div>
    </div>
  );
}
